import * as React from 'react';
import { Typography } from '@mui/material';
import { Field, FieldProps, useFormikContext, getIn } from 'formik';
import { JItem } from '../jformik/jformik.types';

export const FArraySum = (jItem: JItem) => {
  const { values } = useFormikContext();
  const sum: number = getIn(
    values,
    jItem.name.replaceAll(
      jItem?.jItemProps?.itemName,
      jItem?.jItemProps?.arrayName
    )
  )?.reduce(
    (
      accumulator: number,
      currentValue: { custom_input: { value: string } }
    ) => {
      return accumulator + parseInt(currentValue?.custom_input?.value || '0');
    },
    0
  );
  return (
    <Field name={jItem.name}>
      {({ field: { value } }: FieldProps) => (
        <Typography
          id={`${jItem.name}-field`}
          component={'span'}
          {...jItem.jItemProps}
          sx={{
            ...(jItem.jItemProps?.sx || {}),
            color: theme =>
              jItem.disabled
                ? theme.palette.text.disabled
                : jItem.jItemProps?.sx?.color,
          }}
        >
          {`${jItem.label !== '' ? jItem.label : value}${sum}`}
        </Typography>
      )}
    </Field>
  );
};
